import axios from "axios";
import {
    authHeader,
    handleResult,
    handleException,
} from '../helpers';

export const benefitVehicleService = {
    get,
    getByRegistrationNumber,
    save,
    getVehicleInformationByModelCode,
    calculateBenefitValue
};

function get() {
    const requestOptions = {
        headers: authHeader()
    };    
    return axios.get(`benefitvehicle`, requestOptions).then(handleResult).catch(handleException);
}

function getByRegistrationNumber(registrationNumber) {
    const requestOptions = {
        headers: authHeader()
    };    
    return axios.get(`benefitvehicle/${registrationNumber}`, requestOptions).then(handleResult).catch(handleException);
}

function save(benefitVehicle) {
    const requestOptions = {
        headers: authHeader()
    };

    if(!benefitVehicle.id) {
        return axios.post("benefitvehicle/employee/" + benefitVehicle.employeeId, benefitVehicle, requestOptions).then(handleResult).catch(handleException);
    }

    return axios.put("benefitvehicle/" + benefitVehicle.registrationNumber + "?employeeId=" + benefitVehicle.employeeId, benefitVehicle, requestOptions).then(handleResult).catch(handleException);
}

function getVehicleInformationByModelCode(modelCode){
    return axios.get(process.env.VUE_APP_SKATTEVERKET_API + modelCode).then(handleResult).catch(handleException);
}

async function calculateBenefitValue(benefitCalculationValues, newCarPrice){
    const requestOptions = {
        headers: authHeader()
    };
    var json = {
        distanceOverThreeThousand: benefitCalculationValues.distanceOverThreeThousand,
        extraEquipment: benefitCalculationValues.extraEquipment,
        vehicleTax: benefitCalculationValues.vehicleTax,
        newCarPrice: newCarPrice
    }

    return await axios.post("benefitvehicle/benefitcalculation", json, requestOptions).then(handleResult).catch(handleException);
}